import {AppStorage} from '../../service/UserStorage';

import * as languages from './languages.json';

const locale = 'vi';

export function translate(errorCode, message = null): string {
  
  if (errorCode) {
    if (errorCode.includes && errorCode.includes('+')) {
      let result = '';
      errorCode.split('+').forEach((item) => {
        result += ` ${translate(item, message)}`;
      });
      return result.trim();
    } else {
      if (languages[errorCode] && languages[errorCode][locale] !== undefined) {
        return languages[errorCode][locale];
      } else if(message){
        return message;
      }
    }
  }
  return errorCode;
}


let localization;

function getLocalization(): Record<string, string> | undefined {
  if (localization) {
    return localization;
  }
  try {
    localization = JSON.parse(AppStorage.get('localization'));
    return localization;
  } catch (e) {
    return undefined;
  }
}

function resolveLocalizedError(errorKey: string, fallbackMessage?: string): string | undefined {
  const loc = getLocalization();
  if (loc && loc[errorKey]) {
    return loc[errorKey];
  }
  return fallbackMessage;
}

export function translateError(response): string {
 
  // Accept AxiosError shape: { response: { status, data, ... } }
  if (response && typeof response === 'object' && (response as any).response) {
    response = (response as any).response;
  }

  let errors, message;
  let errorMessage: string | undefined;

  if (typeof response === 'object' && response) {
    const errorPayload = (response as any)?.data?.error || (response as any)?.error;
    if (errorPayload && typeof errorPayload.message === 'string' && errorPayload.message) {
      errorMessage = errorPayload.message;
    }

    // Ưu tiên mã lỗi nghiệp vụ (kể cả khi HTTP status là 5xx)
    if (errorPayload) {
      if (errorPayload.code === '9999') {
        message = errorPayload.message;
      } else if (errorPayload.validationErrors && errorPayload.validationErrors.length) {
        let messages = [];
        errorPayload.validationErrors.forEach(validationError => {
          if (validationError.message) {
            messages.push(validationError.message);
          }
        });
        if (messages.length) {
          message = messages.join(', ');
        }
      } else if (errorPayload.code !== undefined && errorPayload.code !== null && errorPayload.code !== '') {
        const errorKey = 'ErrorCode-' + errorPayload.code;
        const localized = resolveLocalizedError(errorKey, errorMessage);
        if (localized) {
          return localized;
        }
        errors = errorKey;
      } else if (errorMessage) {
        return errorMessage;
      }
    }

    // Generic HTTP 5xx — chỉ khi không xử lý được error payload ở trên
    if (typeof response.status === 'number' && response.status >= 500) {
      if (response.data && typeof response.data.message === 'string' && response.data.message) {
        return response.data.message;
      }
      return 'Hệ thống đang bận hoặc gặp sự cố (500). Vui lòng thử lại sau.';
    }

    // ABP-like custom error payload: { code, message, details, ... }
    if (response.data && typeof response.data.message === 'string' && response.data.message) {
      return response.data.message;
    }
  } else if (response) {
    errors = response;
  }

  if (errors) {
    const localized = resolveLocalizedError(errors, errorMessage);
    if (localized) {
      return localized;
    }
  }

  return message || errorMessage || 'Có lỗi xảy ra. Vui lòng kiểm tra lại nghiệp vụ';
}
